module.exports = __webpack_public_path__ + "img/9.faeaa71d.jpg";